<template>
    <div class="oneButton">

    <label class="switch">
      <!-- :disabled='buttonClicked'   -->
      <input
        
        type="checkbox" 
        id="checkbox"
        @change="cameraToggle($event)"
      >
        <!-- :disabled='cameraButtonDisabled' -->
      <span class="slider">
      </span>
      
    </label> 

    <div class="buttonLabel">
      <slot></slot>
    </div>

  </div>

</template>

<script>
export default {

  props: ["componentType"],

  data(){

    console.log(this.componentType);
    let disabled = false
    if(this.componentType == "location"){
      disabled = true
    }
    
    return{
      buttonClicked:disabled
    }
  },

  created: function() {
  },

  mounted:function() {
    // console.log(this.componentName)
  },

  methods: {
    cameraToggle: function(e){
      this.buttonClicked = true;
      this.$emit('toggled',this.componentType);
    }
  }

}
</script>

<style>

.menu input[type="checkbox"] {
    opacity: 0;
}



/* to override the normal background on labels */
  .menu .switch:hover{
    background:none !important;
  }

    /* Basic Rules */
  .menu .switch input { 
      display:none;
  }
  
  .menu .switch {
      background:none !important;
      /* display:inline-block; */
      width:60px;
      height:30px;
      /* margin:8px; */
      margin-bottom:16px;
      margin-right:8px;
      transform:translateY(-20%);
      position:relative;
      float: left;
  }

  /* Style Wired */
  .menu .slider {
      position:absolute;
      top:0;
      bottom:0;
      left:0;
      right:0;
      border-radius:30px;
      box-shadow:0 0 0 2px #ffffff, 0 0 4px #ffffff;
      cursor:pointer;
      border:4px solid transparent;
      overflow:hidden;
      transition:.4s;
  }

  .menu .slider:before {
      position:absolute;
      content:"";
      width:100%;
      height:100%;
      background:#ffffff;
      border-radius:30px;
      transform:translateX(-55px);
      transition:.4s;
  }

  .menu input:checked + .slider:before {
      transform:translateX(3px);
      background:#ED6F29;
  }
  .menu input:checked + .slider {
      box-shadow:0 0 0 2px #ED6F29,0 0 2px #ED6F29;
  }

  /* Style Flat */
  .menu .switch.flat .slider {
  box-shadow:none;
  }
  .menu .switch.flat .slider:before {
    background:#FFF;
  }
  .menu .switch.flat input:checked + .slider:before {
  background:white;
  }
  .menu .switch.flat input:checked + .slider {
    background:#ED6F29;
  }

  .oneButton{
    /* float: left; */
    display:inline-block;
  }

  .buttonLabel{
    float: left;
    vertical-align: middle;
    text-align: right;
    color: white;
  }
</style>